import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="max-w-3xl mx-auto border-4 border-slate-100 rounded-2xl p-8 md:p-12 text-center" data-id="element-22">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-23">
            <ShieldCheck className="w-10 h-10 text-amber-600" data-id="element-24" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-25">
            Garantía de Tranquilidad Total de 30 Días
          </h2>
          <p className="text-slate-600 text-lg mb-6" data-id="element-26">
            Estoy tan seguro de que este material es vital para tu familia que
            asumo todo el riesgo. Si lees el protocolo y no sientes que tu
            familia está más segura, envíame un correo y te devuelvo el 100% de
            tu dinero. Sin preguntas.
          </p>
          <p className="font-bold text-slate-900" data-id="element-27">
            Te quedas con la información gratis. Así de importante es que leas
            esto.
          </p>
        </div>
      </div>
    </section>;
}